import { type PropsWithChildren, forwardRef, useMemo } from 'react';
import { PanelLeftClose, PanelRightClose } from 'lucide-react';
import { useUserSettingsStore } from '@/hooks/data/settings/useUserSettingsStore';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { useTranslations } from 'next-intl';

export const Toolbar = forwardRef<HTMLDivElement, PropsWithChildren & { isUpload?: boolean; className?: string }>(
  ({ children, className, isUpload }, ref) => {
    const showInspector = useUserSettingsStore((s) => s.showInspector);
    const setShowInspector = useUserSettingsStore((s) => s.setShowInspector);
    const showUploadInspector = useUserSettingsStore((s) => s.showUploadInspector);
    const setShowUploadInspector = useUserSettingsStore((s) => s.setShowUploadInspector);
    const tLabels = useTranslations('labels');

    const inspectorState = useMemo(
      () => (isUpload ? showUploadInspector : showInspector),
      [isUpload, showInspector, showUploadInspector],
    );

    const InspectorToggleIcon = inspectorState ? PanelRightClose : PanelLeftClose;

    return (
      <div ref={ref} className={cn('flex max-h-12 min-h-12 items-stretch bg-ui-base', className)}>
        {children}
        <div className="flex shrink-0 items-center gap-x-2 bg-ui-base px-3">
          <Button
            variant="main-toolbar"
            size="main-toolbar"
            data-cy="toolbar-open-inspector-button"
            onClick={() => (isUpload ? setShowUploadInspector(!showUploadInspector) : setShowInspector(!showInspector))}
            icon={InspectorToggleIcon}
            tooltip={inspectorState ? tLabels('hideInspector') : tLabels('showInspector')}
          />
        </div>
      </div>
    );
  },
);

Toolbar.displayName = 'Toolbar';
